import { type TRANSLATION_LOCALES, $i18n_state } from "../SHARED/i18n";

const en = {
  welcome: {
    start: "Welcome",
    end: "to Designathon 2025!",
  },
  caution: "some browsers will refuse to download files directly.",
  guide: {
    label: "guideline",
    instructions:
      "This section contains a link to download the competition instructions, which includes details of the rules, evaluation mechanism, and schedule of events, to help you prepare in the best way possible.",
    button: "guideline",
  },
  badge: {
    label: "Participant entry card",
    instruction:
      "This section includes the steps to add the badge to your Apple Wallet, as well as uploading the official participation badge, making it easy to access the event and verify your identity as an authorized participant.",
    buttons: {
      badge: "Entrance Card",
      addTo: {
        title: "Add to",
        wallet: "apple wallet",
      },
    },
  },
};
const translations: Record<TRANSLATION_LOCALES, TRANSLATION_SCHEMA> = {
  en,
  ar: {
    welcome: {
      start: "مرحبا بك",
      end: "في ديزايناثون 2025",
    },
    caution: "سترفض بعض المتصفحات تنزيل الملفات مباشرةً.",
    guide: {
      label: "الدليل الإرشادي",
      instructions:
        "يحتوي هذا القسم على رابط تحميل تعليمات المسابقة، والتي تتضمن تفاصيل القواعد، آلية التقييم، وجدول الفعاليات، لمساعدتك على الاستعداد بأفضل شكل ممكن.",
      button: "الدليل الإرشادي",
    },
    badge: {
      label: "بطاقة دخول المشارك",
      instruction:
        "يتضمن هذا القسم خطوات إضافة الشارة إلى Apple Wallet، بالإضافة إلى تحميل شارة المشاركة الرسمية، مما يسهل وصولك إلى الفعالية والتحقق من هويتك كمشارك معتمد.",
      buttons: {
        badge: "بطاقة الدخول",
        addTo: {
          title: "إضافة إلى",
          wallet: "apple wallet",
        },
      },
    },
  },
};

export type TRANSLATION_SCHEMA = typeof en;
export const t = () => {
  return translations[$i18n_state.value];
};
